export const extractProfileByLanguage = (language, profiles) => {
  if (!profiles || profiles.length === 0) return null

  const profile = profiles.find((profile) => {
    return profile.language === language
  })

  return profile
}
